import React from "react";
import PropTypes from "prop-types";
import { Radio } from "antd";
import { GrantSectionHeading, TableLabel } from "../../style";
import { GrantSelectedTabs, PaymentLabel, TabsWrapper } from "./style";

function ScheduleGrant({ userTabSelected = "", onChange, disabled }) {
  return (
    <div>
      <GrantSectionHeading>Schedule Grant</GrantSectionHeading>
      <TableLabel className="mt-20 mb-30">
        Note: All grants are subject to Vanguard Charitable's approval. Most grants are reviewed and approved in less than a week.
      </TableLabel>
      <TabsWrapper className="mb-30">
        <PaymentLabel>Select payment type</PaymentLabel>
        <GrantSelectedTabs disabled={disabled} value={userTabSelected} buttonStyle="solid" onChange={onChange}>
          <Radio.Button id="rdOnetimeGrant" value="oneTime">One-time Grant</Radio.Button>
          <Radio.Button id="rdRecurringGrant" value="recurring">Recurring Grant</Radio.Button>
        </GrantSelectedTabs>
      </TabsWrapper>
    </div>
  );
}

ScheduleGrant.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  userTabSelected: PropTypes.string.isRequired
};

export default ScheduleGrant;
